import React from 'react';

import FieldAssigmentItem from './FieldAssigmentItem';

class FieldAssigment extends React.Component {

  constructor(props) {
    super(props);
    this.fieldList = [];
    for(let i = 0; i < props.fields.length; i++) {
      this.fieldList.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
        type: props.fields[i].field_type, label: props.fields[i].label_name });
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(this.props.module !== props.module) {
      this.fieldList = [];
      for(let i = 0; i < props.fields.length; i++) {
        this.fieldList.push({ id: props.fields[i].id, value: props.fields[i].fieldKey,
          type: props.fields[i].field_type, label: props.fields[i].label_name });
      }
    }
  }

  render() {
    let fields = this.props.value.map(fieldAssmnt => {
      const field = this.fieldList.find(field => field.value === fieldAssmnt.field);
      return { key: fieldAssmnt.key, field };
    });
    
    return fields.map((field, i) =>
      <FieldAssigmentItem key={`field_assigment_item_${i}`} value={field} zones={this.props.zones}
        index={i} fields={this.fieldList}  dZone={this.props.dZone} api_data={this.props.api_data}
        onAdd={this.props.onAdd} onEdit={this.props.onEdit} onDelete={this.props.onDelete} onFormat={this.props.onFormat} />
    );
  }
}
export default FieldAssigment;